import React from 'react';

const Terms = () => {
  return (
    <div className="terms-page">
      <div className="hero-section">
        <h1>Terms of Service</h1>
        <p className="subtitle">Please read these terms carefully before using our services</p>
      </div>

      <div className="content-section">
        <div className="terms-grid">
          <div className="terms-card">
            <h2>1. Service Agreement</h2>
            <div className="terms-content">
              <p>By accessing and using HotSide Repairs' platform, you agree to these terms and conditions. Our platform connects commercial kitchen operators with qualified repair service providers.</p>
              <ul>
                <li>Platform access is provided "as is"</li>
                <li>Users must be 18 years or older</li>
                <li>Commercial use only - not for residential services</li>
                <li>Account registration required for service providers</li>
              </ul>
            </div>
          </div>

          <div className="terms-card">
            <h2>2. Service Provider Terms</h2>
            <div className="terms-content">
              <p>Service providers listed on our platform must adhere to specific requirements:</p>
              <ul>
                <li>Valid business licenses and insurance</li>
                <li>Certified technicians only</li>
                <li>Compliance with local regulations</li>
                <li>Maintain minimum service standards</li>
                <li>Accurate representation of services</li>
              </ul>
            </div>
          </div>

          <div className="terms-card">
            <h2>3. User Responsibilities</h2>
            <div className="terms-content">
              <p>Users of the platform agree to:</p>
              <ul>
                <li>Provide accurate information</li>
                <li>Maintain account security</li>
                <li>Report issues promptly</li>
                <li>Pay for services as agreed</li>
                <li>Respect service provider policies</li>
              </ul>
            </div>
          </div>

          <div className="terms-card">
            <h2>4. Service Guarantees</h2>
            <div className="terms-content">
              <p>Our service guarantees include:</p>
              <ul>
                <li>Verified service providers</li>
                <li>Quality assurance standards</li>
                <li>Customer satisfaction policy</li>
                <li>Dispute resolution process</li>
              </ul>
            </div>
          </div>

          <div className="terms-card">
            <h2>5. Liability Limitations</h2>
            <div className="terms-content">
              <p>HotSide Repairs' liability is limited to:</p>
              <ul>
                <li>Platform functionality only</li>
                <li>No direct service provision</li>
                <li>Limited to connection services</li>
                <li>Case-by-case dispute resolution</li>
              </ul>
            </div>
          </div>

          <div className="terms-card">
            <h2>6. Privacy & Data</h2>
            <div className="terms-content">
              <p>Our data handling practices include:</p>
              <ul>
                <li>Secure data storage</li>
                <li>Limited data sharing</li>
                <li>User privacy protection</li>
                <li>Compliance with regulations</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="contact-section">
          <h2>Questions About Our Terms?</h2>
          <p>Contact our legal team for clarification</p>
          <a href="/contact" className="contact-button">Contact Us</a>
        </div>
      </div>

      <style>
        {`
          .terms-page {
            min-height: 100vh;
            background: linear-gradient(145deg, #1a1a1a, #000);
            color: #fff;
          }

          .hero-section {
            padding: 6rem 2rem;
            text-align: center;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-bottom: 4px solid #ff6b35;
            position: relative;
          }

          .hero-section h1 {
            font-size: 3.5rem;
            font-weight: 800;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 2px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
          }

          .subtitle {
            font-size: 1.5rem;
            color: rgba(255,255,255,0.9);
            max-width: 800px;
            margin: 0 auto;
            font-weight: 300;
          }

          .content-section {
            max-width: 1200px;
            margin: 0 auto;
            padding: 4rem 2rem;
          }

          .terms-grid {
            display: grid;
            gap: 2rem;
            margin-bottom: 4rem;
          }

          .terms-card {
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            padding: 2rem;
            border: 2px solid rgba(255,255,255,0.1);
            transition: all 0.3s ease;
          }

          .terms-card:hover {
            border-color: rgba(255, 107, 53, 0.2);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.1);
          }

          .terms-card h2 {
            font-size: 1.75rem;
            color: #ff6b35;
            margin-bottom: 1.5rem;
            text-transform: uppercase;
            letter-spacing: 1px;
            text-shadow: 1px 1px 2px rgba(0,0,0,0.3);
          }

          .terms-content {
            color: rgba(255,255,255,0.9);
          }

          .terms-content p {
            font-size: 1.1rem;
            line-height: 1.6;
            margin-bottom: 1rem;
          }

          .terms-content ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
          }

          .terms-content ul li {
            position: relative;
            padding-left: 1.5rem;
            margin-bottom: 0.75rem;
            font-size: 1.1rem;
            line-height: 1.5;
          }

          .terms-content ul li::before {
            content: '•';
            color: #ff6b35;
            position: absolute;
            left: 0;
            font-weight: bold;
          }

          .contact-section {
            text-align: center;
            padding: 3rem;
            background: linear-gradient(145deg, #2a2a2a, #1a1a1a);
            border-radius: 12px;
            border: 2px solid rgba(255,255,255,0.1);
          }

          .contact-section h2 {
            font-size: 2.5rem;
            color: #ff6b35;
            margin-bottom: 1rem;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .contact-section p {
            font-size: 1.25rem;
            color: rgba(255,255,255,0.9);
            margin-bottom: 2rem;
          }

          .contact-button {
            display: inline-block;
            background: linear-gradient(145deg, #ff6b35, #e65d2e);
            color: white;
            text-decoration: none;
            padding: 1rem 2rem;
            border-radius: 6px;
            font-size: 1.1rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 1px;
            transition: all 0.3s ease;
            border: none;
          }

          .contact-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(255, 107, 53, 0.2);
          }

          @media (max-width: 768px) {
            .hero-section h1 {
              font-size: 2.5rem;
            }

            .subtitle {
              font-size: 1.25rem;
            }

            .content-section {
              padding: 2rem 1rem;
            }

            .terms-card h2 {
              font-size: 1.5rem;
            }

            .terms-content p,
            .terms-content ul li {
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Terms;